import { render } from "./CheckoutPage.vue?vue&type=template&id=842881c2&ts=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__